import { useEffect } from 'react';

export const APP_NAME = 'Hélios';

/**
 * Sets document.title for accessibility and browser tab identification.
 * Usage: usePageTitle('Clients') → "Clients — Hélios"
 */
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
    return () => { document.title = APP_NAME; };
  }, [title]);
}
